import React from 'react';
import PropTypes from 'prop-types';
import Link, { navigateTo } from 'gatsby-link';
import Helmet from 'react-helmet';

import {
  HeroBanner,
  CardsBanner,
  Card,
  NosMarques,
  HeroPhoto,
  QuiSommesNousBanner,
  LatestBlogBanner,
  PostCard,
  ButtonVoirTous,
} from '../Main/home/index';

import ContactUs from '../Footer/ContactUs';

const Home = props => {
  const { data, blogPosts } = props;

  const hreflang = data.node_locale === 'fr' ? 'en' : 'fr';

  return (
    <div>
      <Helmet>
        <html lang={data.node_locale} />
        <title>{data.title}</title>
        <meta name="description" content={data.description} />
        <link
          rel="alternate"
          hreflang={hreflang}
          href={`https://www.offshoreservices.fr/${hreflang}/`}
        />
      </Helmet>
      {/* HERO BANNER */}
      <HeroBanner
        heroBannerTexte={data.heroBannerTexte.heroBannerTexte}
        heroImage={data.heroImage}
        heroImageSmall={data.heroImageSmall}
        enSavoirPlus={data.enSavoirPlus.enSavoirPlus}
        link={`/${data.node_locale}/about`}
      />

      {/* NOS MARQUES BANNER */}
      <NosMarques
        className="container"
        marquesBannerTitle={data.marquesBannerTitle.marquesBannerTitle}
        logosMarquesFull={data.logosMarquesFull}
        logosMarquesSmall={data.logosMarquesSmall}
        marquesBannerBody={data.marquesBannerBody.childMarkdownRemark.html}
      />

      {/* HERO PHOTO */}
      <HeroPhoto
        heroPhoto={data.heroPhoto}
        heroPhotoSmall={data.heroPhotoSmall}
      />

      {/* CARD BANNER */}
      <CardsBanner>
        <div className="container">
          <div
            dangerouslySetInnerHTML={{
              __html: data.servicesBannerTitle.childMarkdownRemark.html,
            }}
          />
          <div className="row">
            <div className="col-md-4">
              <Card
                icon="build"
                title={data.cardVenteTitle.cardVenteTitle}
                link={`/${data.node_locale}/services`}
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.cardVenteBody.childMarkdownRemark.html,
                  }}
                />
              </Card>
            </div>
            <div className="col-md-4">
              <Card
                icon="directions_boat"
                title={data.cardInstallTitle.cardInstallTitle}
                link={`/${data.node_locale}/services`}
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.cardInstallBody.childMarkdownRemark.html,
                  }}
                />
              </Card>
            </div>
            <div className="col-md-4">
              <Card
                icon="verified_user"
                title={data.cardAnalysesTitle.cardAnalysesTitle}
                link={`/${data.node_locale}/services`}
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.cardAnalysesBody.childMarkdownRemark.html,
                  }}
                />
              </Card>
            </div>
          </div>
        </div>
      </CardsBanner>

      {/* QUI SOMMES NOUS */}
      <QuiSommesNousBanner
        className="container"
        carouselImages={data.carouselImages}
        aboutBannerTitle={data.aboutBannerTitle.aboutBannerTitle}
        aboutBannerBody={data.aboutBannerBody.childMarkdownRemark.html}
      />

      {/* LATEST BLOG POSTS */}
      <LatestBlogBanner blogBannerTitle={data.blogBannerTitle.blogBannerTitle}>
        <div className="container">
          <div className="row">
            {blogPosts &&
              blogPosts.map((blogPost, i) => {
                return (
                  <div key={i} className="col-md-4">
                    <PostCard
                      blogPost={blogPost}
                      timeToRead={data.timeToRead}
                      lireArticle={data.lireArticle}
                    />
                  </div>
                );
              })}
          </div>
          <center className="blog-button">
            <ButtonVoirTous
              onClick={() => navigateTo(`/${data.node_locale}/blog`)}
              voirTous={data.voirTous}
            />
          </center>
        </div>
      </LatestBlogBanner>

      <ContactUs locale={data.node_locale} />
    </div>
  );
};

Home.propTypes = {
  data: PropTypes.object,
  blogPosts: PropTypes.array,
};

export default Home;



// WEBPACK FOOTER //
// ./src/components/Pages/Home.js